<template lang="pug">
.usuarios.container.grid-lg.py-2
  .usuario
    load-manager(:status="status")
      .card(v-if="current")
        .card-header
          .card-title
            b {{ current.login | cpfCnpj }}&nbsp;
            span {{ current.nome }}
            .pb-2 {{ current.email }}
          .pb-2
            label Média Mensal:
            span.text-bold &nbsp;{{ mediaMensal | currency }}
            .text-small(v-if="mediaMensal <= 0")
              small.label.label-secondary O Usuário não possui Média Mensal anterior
          .py-2
            button.btn.btn-link(@click="showAdd = true")
              btn-content(name="new", label="Novo Afastamento")
        .card-body
          table.table.table-striped.table-sm(
            v-if="afastamento && afastamento.rows && afastamento.rows.length"
          )
            thead
              tr
                th {{ "afastamento.inicia_em" | tModel }}
                th {{ "afastamento.termina_em" | tModel }}
                th {{ "afastamento.dias_afastado" | tModel }}
                th {{ "afastamento.dias_uteis_afastado" | tModel }}
                th {{ "afastamento.observacao" | tModel }}
                th(width="1")
            tbody
              tr(v-for="row in afastamento.rows")
                td {{ row.inicia_em | date("DD/MM/YYYY") }}
                td {{ row.termina_em | date("DD/MM/YYYY") }}
                td {{ row.dias_afastado }}
                td {{ row.dias_uteis_afastado }}
                td.text-small {{ row.observacao }}
                td.c-hand(@click="destroy(row)")
                  i.fa.fa-trash.text-error
      modal(
        :active="showAdd",
        title="Incluir Período de Afastamento",
        @close="showAdd = false"
      )
        div(slot="modal-body")
          .columns
            .column.col-6.col-sm-12
              form-group(
                label="Data inicial",
                :validation="$v.params.data_inicio"
              )
                datepicker(v-model="$v.params.data_inicio.$model")
            .column.col-6.col-sm-12
              form-group(
                label="Data final",
                :validation="$v.params.data_final"
              )
                datepicker(v-model="$v.params.data_final.$model")
          form-group(label="Observação", :validation="$v.params.observacao")
            input.form-input(v-model="$v.params.observacao.$model")
        div(slot="modal-footer")
          button.btn.btn-primary(
            :class="{ loading: loading }",
            @click="save",
            :disabled="$v.$invalid || loading"
          )
            btn-content(name="save")
</template>

<script>
import { maxLength, minLength, required } from "vuelidate/lib/validators"
import api from "@/api/produtividade/afastamentos"

export default {
  vuex: {
    "sistema/usuarios": {
      state: ["current", "status"],
      actions: ["fetchOne"],
    },
  },

  data() {
    return {
      params: { data_inicio: "", data_final: "", observacao: "" },
      afastamento: { rows: [] },
      mediaMensal: 0,
      loading: false,
      showAdd: false,
    }
  },

  computed: {
    usuarioId() {
      return Number(this.$route.params.id)
    },
  },

  methods: {
    isFetchOne() {
      return !this.current || Number(this.current.id) !== this.usuarioId
    },

    async fetchList() {
      this.loading = true
      try {
        this.afastamento = await api.list(this.current.id)
      } catch (e) {
        this.$toaster.error(e.message)
      }
      this.loading = false
    },

    async fetchMediaMensal() {
      this.loading = true
      try {
        const res = await api.mediaMensal(this.current.id)
        this.mediaMensal = res.media
      } catch (e) {
        this.$toaster.error(e.message)
      }
      this.loading = false
    },

    save() {
      this.loading = true
      api
        .create(this.usuarioId, this.params)
        .then((res) => {
          this.$toaster.success("Salvo com sucesso.")
          this.loading = false
          this.showAdd = false
          this.fetchList()
        })
        .catch((e) => {
          this.$toaster.error(e.message)
          this.loading = false
        })
    },

    destroy(afastamento) {
      const options = { cancelLabel: "Não", title: "Confirmação" }
      this.$dialogs
        .confirm("Tem certeza que desja remover o afastamento?", options)
        .then((d) => {
          if (d.ok) {
            this.loading = true
            api
              .destroy(afastamento.id)
              .then(() => {
                this.loading = false
                this.$toaster.success("Deletado com sucesso.")
                this.fetchList()
              })
              .catch((e) => {
                this.$toaster.error(e.message)
                this.loading = false
              })
          }
        })
    },
  },

  async mounted() {
    if (this.isFetchOne()) {
      await this.fetchOne(this.usuarioId)
      this.fetchList()
      this.fetchMediaMensal()
    } else {
      this.fetchList()
      this.fetchMediaMensal()
    }
  },

  validations: {
    params: {
      data_inicio: { required },
      data_final: { required },
      observacao: {
        required,
        minLength: minLength(5),
        maxLength: maxLength(100),
      },
    },
  },
}
</script>

<style src="./usuarios.styl" lang="stylus"></style>
